import React from "react";
import { useTranslation } from "react-i18next";
import "./SideMenu.css";

type SideMenuItem = {
  label: string;
  href: string;
};

type SideMenuProps = {
  onItemClick?: () => void;
};

export default function SideMenu({ onItemClick }: SideMenuProps) {
  const { t } = useTranslation();

  const menuItems: SideMenuItem[] = [
    { label: t("home"), href: "/" },
    { label: t("registration"), href: "/escolha-tipo-inscricao" },
    { label: t("mySchedules"), href: "/meus-horarios" },
    { label: t("emailOccurrence"), href: "/ocorrencia" },
    { label: t("digitalShift"), href: "/plantao-digital" },
    { label: t("pages.configuration.title"), href: "/config" }
  ];
  return (
    <aside className="side-menu">
      {/* <div className="side-menu__title">MENU</div> */}
      <nav className="side-menu__list">
        {menuItems.map((item) => (
          <a
            key={item.label}
            href={item.href}
            className="side-menu__item"
            onClick={onItemClick}
          >
            {item.label}
          </a>
        ))}
      </nav>
    </aside>
  );
}
